import React from 'react';
import { Box } from '@mui/material';
import { coverStripes as styles } from './styles';

function CoverStripes() {
    return (
        <Box sx={styles.wrapper}>
            <Box sx={styles.bar1} />
            <Box sx={styles.bar2} />
            <Box sx={styles.bar3} />
        </Box>
    );
}

export default CoverStripes;
